import { render } from "./TicketTestRoom.vue?vue&type=template&id=5a03a1c8&scoped=true"
import script from "./TicketTestRoom.vue?vue&type=script&lang=js"
export * from "./TicketTestRoom.vue?vue&type=script&lang=js"

import "./TicketTestRoom.vue?vue&type=style&index=0&id=5a03a1c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a03a1c8"]])

export default __exports__